import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isBooleanListField, isBooleanSingleField, isComponentListField, isComponentSingleField, isLocationListField, isLocationSingleField, isNumberListField, isNumberSingleField, isReferenceListField, isReferenceSingleField, isRichTextListField, isRichTextSingleField, isStringListField, isStringSingleField, } from '@dossierhq/core';
import { Text } from '@dossierhq/design';
import { useContext } from 'react';
import { PublishedDossierContext } from '../../contexts/PublishedDossierContext.js';
import { BooleanFieldDisplay } from './BooleanFieldDisplay.js';
import { ComponentFieldDisplay } from './ComponentFieldDisplay.js';
import { FieldDisplayListWrapper } from './FieldDisplayListWrapper.js';
import { LocationFieldDisplay } from './LocationFieldDisplay.js';
import { NumberFieldDisplay } from './NumberFieldDisplay.js';
import { ReferenceFieldDisplay } from './ReferenceFieldDisplay.js';
import { RichTextFieldDisplay } from './RichTextFieldDisplay.js';
import { StringFieldDisplay } from './StringFieldDisplay.js';
export function FieldDisplay(props) {
    const { fieldSpec, value } = props;
    const { adapter } = useContext(PublishedDossierContext);
    const overriddenDisplay = adapter.renderPublishedFieldDisplay(props);
    if (overriddenDisplay) {
        return overriddenDisplay;
    }
    if (value === null) {
        return (_jsx(Text, { textStyle: "body1", children: _jsx("em", { children: "Empty" }) }));
    }
    let display;
    if (isBooleanSingleField(fieldSpec, value)) {
        display = (_jsx(BooleanFieldDisplay, { fieldSpec: fieldSpec, value: value }));
    }
    else if (isBooleanListField(fieldSpec, value)) {
        display = (_jsx(FieldDisplayListWrapper, { fieldSpec: fieldSpec, value: value, Display: BooleanFieldDisplay }));
    }
    else if (isReferenceSingleField(fieldSpec, value)) {
        display = (_jsx(ReferenceFieldDisplay, { fieldSpec: fieldSpec, value: value }));
    }
    else if (isReferenceListField(fieldSpec, value)) {
        display = (_jsx(FieldDisplayListWrapper, { fieldSpec: fieldSpec, value: value, Display: ReferenceFieldDisplay }));
    }
    else if (isLocationSingleField(fieldSpec, value)) {
        display = (_jsx(LocationFieldDisplay, { fieldSpec: fieldSpec, value: value }));
    }
    else if (isLocationListField(fieldSpec, value)) {
        display = (_jsx(FieldDisplayListWrapper, { fieldSpec: fieldSpec, value: value, Display: LocationFieldDisplay }));
    }
    else if (isNumberSingleField(fieldSpec, value)) {
        display = (_jsx(NumberFieldDisplay, { fieldSpec: fieldSpec, value: value }));
    }
    else if (isNumberListField(fieldSpec, value)) {
        display = (_jsx(FieldDisplayListWrapper, { fieldSpec: fieldSpec, value: value, Display: NumberFieldDisplay }));
    }
    else if (isRichTextSingleField(fieldSpec, value)) {
        display = (_jsx(RichTextFieldDisplay, { fieldSpec: fieldSpec, value: value }));
    }
    else if (isRichTextListField(fieldSpec, value)) {
        display = (_jsx(FieldDisplayListWrapper, { fieldSpec: fieldSpec, value: value, Display: RichTextFieldDisplay }));
    }
    else if (isStringSingleField(fieldSpec, value)) {
        display = (_jsx(StringFieldDisplay, { fieldSpec: fieldSpec, value: value }));
    }
    else if (isStringListField(fieldSpec, value)) {
        display = (_jsx(FieldDisplayListWrapper, { fieldSpec: fieldSpec, value: value, Display: StringFieldDisplay }));
    }
    else if (isComponentSingleField(fieldSpec, value)) {
        display = (_jsx(ComponentFieldDisplay, { fieldSpec: fieldSpec, value: value }));
    }
    else if (isComponentListField(fieldSpec, value)) {
        display = (_jsx(FieldDisplayListWrapper, { fieldSpec: fieldSpec, value: value, Display: ComponentFieldDisplay }));
    }
    else {
        display = _jsxs("div", { children: [`${fieldSpec.type} (list: ${!!fieldSpec.list})`, " is not supported"] });
    }
    return display;
}
//# sourceMappingURL=FieldDisplay.js.map